import { render, staticRenderFns } from "./PrivacyLinks.vue?vue&type=template&id=c6b74544&"
import script from "./PrivacyLinks.vue?vue&type=script&lang=ts&"
export * from "./PrivacyLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports